import React from 'react';
import '../icon-component.scss';

const BulkEditComponent = () => (
  <svg className="icon-component" viewBox="0 0 24.54 20.64">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3.04,8.64 h10" className="icon-component--none" />
      <path d="M3.04,11.64 h6" className="icon-component--none" />
      <path d="M13.30,18.3 H.51 V5.57 h19.03 V9.33" className="icon-component--none" />
      <path d="M2.51,5.57 v-2 h19.03 V10.29" className="icon-component--none" />
      <path d="M4.51,3.48 v-2 h19.03 V12.87" className="icon-component--none" />
      <path d="M18.2,9.3 m-5.5,5.5 a5.5,5.5 0 1,0 11,0 a5.5,5.5 0 1,0 -11,0" className="icon-component--none" />
      <path
        d="M16.5,17.31 h3.64 m-1.82,0 v-4.7 m-0.05,-0.2 l1.8,1.8 m-1.8,-1.8 l-1.8,1.8"
        className="icon-component--none"
      />
    </g>
  </svg>
);

BulkEditComponent.displayName = 'BulkEditIcon';

export default BulkEditComponent;
